import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ p: 2, textAlign: 'center', backgroundColor: '#1E1E1E' }}>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        © {new Date().getFullYear()} Homegrown Genetics: SES Email Template Manager. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
